import translateDbField from "@/utils/translateDbField";

export const UNIT_ACCESS_TRANSLATION_KEY = "database.permissions.unitAccess";

const UNIT_ACCESS_PREFIXES = [
  "Acesso Unidade",
  "Acceso Unidad",
];

/**
 * Extrai o código da unidade da descrição gravada no banco
 * (ex.: "Acesso Unidade ABC" → "ABC"), quando o join não traz cod_unidade.
 */
export function extractUnitCodeFromDescricao(descricao) {
  if (typeof descricao !== "string") return null;
  const trimmed = descricao.trim();
  if (!trimmed) return null;

  for (const prefix of UNIT_ACCESS_PREFIXES) {
    if (trimmed.toLowerCase().startsWith(prefix.toLowerCase())) {
      const rest = trimmed.slice(prefix.length).trim();
      return rest || null;
    }
  }

  // fallback: último token após espaço (descrições "base código")
  const parts = trimmed.split(/\s+/);
  if (parts.length >= 2) {
    return parts[parts.length - 1] || null;
  }
  return null;
}

/**
 * Formata a descrição exibida de uma permissão, preservando o código
 * nas permissões de unidade mesmo com translation_key genérica.
 */
export default function formatPermissaoDescricao(permissao) {
  if (!permissao) return "";

  const key = permissao.translation_key;
  const raw = permissao.descricao_permissao || "";

  if (key === UNIT_ACCESS_TRANSLATION_KEY) {
    const base = translateDbField(key, "Acesso Unidade");
    const code =
      (permissao.cod_unidade != null && String(permissao.cod_unidade).trim() !== ""
        ? String(permissao.cod_unidade).trim()
        : null) || extractUnitCodeFromDescricao(raw);

    return code ? `${base} ${code}` : (raw || base);
  }

  return translateDbField(key, raw);
}
